import { createRouter, createWebHashHistory } from 'vue-router'


const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../components/HomeView.vue'),
    },



    {
      path: '/:serviceId/map',
      name: 'map',
      component: () => import('../components/MapView.vue'),
      props: true,
    },

    {
      path: '/:serviceId/page',
      name: 'page',
      component: () => import('../components/PageView.vue'),
      props: true,
    },


  ],
})

export default router
